import { useState } from "react"
import { DateClass } from "../clases/DateClass"
import PrimaryButton from "../Components/Button/PrimaryButton"
import PrimaryTextField from "../Components/PrimaryTextField/PrimaryTextField"
import SingleSelect from "../Components/Select/SingleSelect"
import { useTranslation } from "react-i18next";
import CancelIcon from '@mui/icons-material/Cancel';
import DefaultModal from "./DefaultModal"
import { useSupabaseData } from "../Hooks"


const CreatorModal = ({ info, id, reset, getAll }) => {
    const { t } = useTranslation()
    const [date, ] = useState(new DateClass(info.attributes.validTo))
    const [openModal, setOpenModal] = useState(false)
    const { DELETE, update } = useSupabaseData({ name: 'formos_tipai' }, []);

    return (
        <div className="row creatormodal" key={id + '-' + info.attributes.formosPavadinimas}>
            <div className="row creatormodalTextfields">
                {info.attributes.email}
                {info.attributes.username}
                <PrimaryTextField
                    label={'formosPavadinimas'}
                    defaultValue={info.attributes.formosPavadinimas}
                    onChange={(e) => { info.attributes.formosPavadinimas = e.trim() }}
                    size='small'
                    classNameForm='txtFieldForm'
                />

                {/* <PrimaryTextField
                    label={'tipas'}
                    defaultValue={info.attributes.kasPildo}
                    onChange={(e) => { info.attributes.kasPildo = e }}
                    size='small'

                /> */}
                <SingleSelect
                    classNameBox='selectRes'
                    classNameForm='selectRes'
                    options={t('tipas')}
                    optionsText={t('tipas_text')}
                    label={t('tipas_label')}
                    size='small'
                    current={info.attributes.kasPildo}
                    set={(l) => {
                        info.attributes.kasPildo = l
                    }}
                />
                <input className="datePicker" defaultValue={date.getYear() || new DateClass(new Date()).getYear()} type={'number'} min={new DateClass(new Date()).getYear()} max="2099" onChange={e => { info.attributes.validTo = new Date(e.currentTarget.value) }} />
                {/* <PrimaryTextField
                    label={'statusas'}
                    size='small'
                    defaultValue={info.attributes.type}
                    onChange={(e) => { info.attributes.type = e }}
                /> */}
                <SingleSelect
                    classNameBox='selectRes'
                    classNameForm='selectRes'
                    options={t('statusas')}
                    optionsText={t('statusas_text')}
                    label={t('statusas_label')}
                    current={info.attributes.type}
                    size='small'

                    set={(l) => {
                        info.attributes.type = l
                    }}
                />
            </div>
            <div className="row formModal">
                <PrimaryButton
                    text={'trinti'}
                    sx={{
                        boxShadow: 0,':hover': {
                           
                             boxShadow: 1, backgroundColor: "white",
                             },
                     }}
                    className='trinti fit_content'
                    variant='text'
                    endIcon={<CancelIcon />}
                    onClick={() => {
                        setOpenModal(true)
                    }}
                />
                <PrimaryButton
                    text={'issaugoti'}
                    onClick={() => {
                        update(id, info.attributes).then(reset)
                    }}
                    className='fit_content capitalize'
                />

            </div>
            <DefaultModal
                modal={openModal}
                setModal={setOpenModal}
                element={
                    <div className="centerContainer1">
                        <p className="modalTxt">{t('arIstrintApklausa')}</p>
                        <div className="row modalBtnCont">
                            <PrimaryButton
                                text='taip'
                                className='margin modalBtn'
                                onClick={() => {
                                    setOpenModal(false);
                                    DELETE(id, getAll)
                                }}
                            />
                            <PrimaryButton
                                text='ne'
                                className='margin modalBtn'

                                onClick={() => {
                                    setOpenModal(false)
                                }}
                            />

                        </div>
                    </div>
                }
            />
        </div>)
}
export default CreatorModal
